export function StartNewChatModal({startNewChatDialogs,handleModalResponse}) {
    return (
        <div className="modal fade show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content text-center">
                    <div className="modal-header border-0">
                        <h5 className="modal-title text-primary fw-bold w-100">Start New Chat</h5>
                    </div>
                    <div className="modal-body">
                        <p className="card-text">{startNewChatDialogs.QUESTION}</p>
                    </div>
                    <div className="modal-footer border-0 justify-content-center">
                        <button 
                            type="button" 
                            className="btn btn-outline-primary" 
                            onClick={() => handleModalResponse(false)}
                        >
                            {startNewChatDialogs.YES}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-outline-primary ms-3" 
                            onClick={() => handleModalResponse(true)}
                        >
                            {startNewChatDialogs.NO}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}